import { render } from "./CoursesSection.vue?vue&type=template&id=5d5ce44e"
import script from "./CoursesSection.vue?vue&type=script&lang=js"
export * from "./CoursesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__